import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import { useInstance, findDomFromVNode, createVNode as h } from 'intact-vue-next';
import { nextFrame, swap } from '../utils';
import { useState, watchState } from '../../hooks/useState';
import { Virtual } from '../virtual';
import { cx } from '@emotion/css';
export function useDraggable(originVNodes) {
  var instance = useInstance();
  var children = useState([]);
  var draggingKey = useState(null);
  var draggingIndex = -1;
  var originIndex = -1;
  var lastOverIndex = -1; /* let the dragover event only trigger once when tags changed order */
  watchState(originVNodes, render);
  watchState(draggingKey, render);
  function render() {
    var _context;
    var _instance$get = instance.get(),
      draggable = _instance$get.draggable;
    children.set(!draggable ? originVNodes.value : _mapInstanceProperty(_context = originVNodes.value).call(_context, function (vNode, index) {
      var key = vNode.key;
      return h(Virtual, {
        'ev-dragstart': function evDragstart() {
          return onStart(key, index);
        },
        'ev-dragover': function evDragover(e) {
          return onOver(e, key, index);
        },
        'ev-dragend': function evDragend(e) {
          return onEnd(e);
        },
        key: key,
        draggable: draggable,
        className: cx({
          'k-dragging': key === draggingKey.value,
          'k-draggable': draggable
        })
      }, vNode);
    }));
  }
  function onStart(key, index) {
    draggingIndex = originIndex = index;
    nextFrame(function () {
      draggingKey.set(key);
    });
    instance.trigger('dragstart', {
      key: key,
      from: index
    });
  }
  function onOver(e, key, index) {
    e.preventDefault();
    e.stopPropagation();
    // Dragging the tag of another tags drag to this tags should be ignored
    if (draggingIndex === -1) return;
    if (lastOverIndex === index) return;
    lastOverIndex = index;
    if (index === draggingIndex) return;
    // if the tag has move transition, you cannot drag over it before transition ended.
    var dom = findDomFromVNode(children.value[index], true);
    if (dom.classList.contains('k-fade-move')) return;
    var vNodes = swap(originVNodes.value, draggingIndex, index);
    lastOverIndex = draggingIndex;
    draggingIndex = index;
    originVNodes.set(vNodes);
  }
  function onEnd(e) {
    e.preventDefault();
    instance.trigger('dragend', {
      key: draggingKey.value,
      from: originIndex,
      to: draggingIndex
    });
    draggingKey.set(null);
    lastOverIndex = -1;
    draggingIndex = -1;
    originIndex = -1;
  }
  return children;
}